class Event{
    constructor(){
        this.events = {};
    }

    on(name, callback) {
        this.events[name] = this.events[name] || [];

        this.events[name].push(callback);
    }

    off(name, callback) {
        this.events[name] = (this.events[name] || []).filter((event) => {
            return event !== callback;
        })
    }

    trigger(name, data) {
        (this.events[name] || []).forEach(function(callback) {
            callback(data);
        });
    }
}

export default new Event();
